/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPrescription = createReactComponent("prescription", "IconPrescription", [
  ["path", { d: "M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5", key: "svg-0" }],
  ["path", { d: "M19 21l-9 -9", key: "svg-1" }],
  ["path", { d: "M13 21l6 -6", key: "svg-2" }]
]);

export { IconPrescription as default };
//# sourceMappingURL=IconPrescription.js.map
